import { FC, useEffect } from 'react';
import { useHits } from 'react-instantsearch';
import { AlgoliaProductHit } from '../../shared/types';
import { AlgoliaUtil } from '../../shared/utils';
import { calculateAvailabilityAndLeadTime, type InventoryPolicy } from '../../helpers/availability-lead-time';

type SearchDataLayerProps = {
  searchTerm: string;
  algoliaUtil: AlgoliaUtil;
};

export const SearchResultDataLayer: FC<SearchDataLayerProps> = ({ searchTerm, algoliaUtil }) => {
  const { results } = useHits<AlgoliaProductHit>();

  useEffect(() => {
    if (results?.hits?.length) {
      window.ultimateShopifyDataLayer?.sendSearchPageData(
        searchTerm,
        results?.hits
          ?.map((hit: AlgoliaProductHit) => ({ rawHit: hit, hit: algoliaUtil.normalizeProductHit(hit) }))
          ?.map(({ hit, rawHit }) => {
            const { availabilityStatus, leadTime } = calculateAvailabilityAndLeadTime(
              hit.leadTimeArray,
              hit.variantsInventoryCount,
              hit.inventoryPolicy as InventoryPolicy,
              1,
              hit.useUp
            );

            return {
              product_title: hit.title,
              sku: hit.sku,
              variant_id: Number(hit.objectID),
              vendor: rawHit.vendor,
              final_price: hit.basePrice * 100,
              quantity: 1,
              availability: availabilityStatus,
              lead_time: leadTime,
            };
          })
      );
    }
  }, [results?.queryID]);

  return null;
};
